import React from 'react';

/**
 * MobileSlider - A wrapper component that makes child boxes slide on mobile
 * 
 * Usage:
 * <MobileSlider cols={3}>
 *   <div>Box 1</div>
 *   <div>Box 2</div>
 *   <div>Box 3</div>
 * </MobileSlider>
 * 
 * Props:
 * - children: React nodes to be displayed as sliding boxes
 * - className: Additional classes for the container
 * - cols: Number of columns on desktop (2, 3, or 4) - defaults to 3
 * - gap: Gap size (defaults to 'gap-8')
 */
const MobileSlider = ({ children, className = '', cols = 3, gap = 'gap-8' }) => {
  const colsClass = cols === 2 ? 'lg:grid-cols-2' : cols === 4 ? 'lg:grid-cols-4' : 'lg:grid-cols-3';
  
  return (
    <div className={`
      ${className}
      md:grid md:grid-cols-2 ${colsClass} md:${gap}
      flex md:flex-none
      overflow-x-auto md:overflow-visible
      snap-x snap-mandatory
      scrollbar-hide
      gap-4
      pb-4
      -mx-4 px-4 md:mx-0 md:px-0
    `}>
      {React.Children.map(children, (child) => (
        <div className="
          flex-shrink-0
          w-[85vw] md:w-auto
          snap-center md:snap-none
        ">
          {child}
        </div>
      ))}
    </div>
  );
};

export default MobileSlider;
